/**
 * Custom hook for managing OTP resend timer
 */
import { useState, useEffect } from "react"

const INITIAL_TIMER = 60

interface UseOTPTimerReturn {
  timer: number
  canResend: boolean
  resetTimer: () => void
}

export const useOTPTimer = (initialTime: number = INITIAL_TIMER): UseOTPTimerReturn => {
  const [timer, setTimer] = useState(initialTime)
  const [canResend, setCanResend] = useState(false)

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [timer])

  const resetTimer = () => {
    setTimer(initialTime)
    setCanResend(false)
  }

  return {
    timer,
    canResend,
    resetTimer,
  }
}

